import type { SupportedLanguage, SupportedLanguagesResponse } from "@stss/types";
import axios from "axios";
import type { AxiosRequestConfig } from "axios";

const CDN_BASE_URL = process.env.NEXT_PUBLIC_ST_CDN_BASE_URL || "";

export async function getAllowedLanguages() {
  const config: AxiosRequestConfig = {
    method: "GET",
    url: CDN_BASE_URL + "/locale/supported_languages_v3.json",
  };
  return new Promise<SupportedLanguagesResponse>((resolve, reject) => {
    axios(config)
      .then((response) => {
        const toReturn: SupportedLanguagesResponse = {
          ui: [],
          captions: [],
          lpt: [],
        };
        const languages: SupportedLanguage[] = response.data;
        if (languages.some((lang) => Array.isArray(lang.using))) {
          languages.forEach((lang) => {
            if (Array.isArray(lang.using)) {
              lang.using.forEach((using) => {
                if (using === "ui") {
                  toReturn.ui.push(lang);
                } else if (using === "captions") {
                  toReturn.captions.push(lang);
                } else if (using === "lpt") {
                  toReturn.lpt.push(lang);
                }
              });
            }
          });
        } else {
          toReturn.ui = languages;
          toReturn.captions = languages;
          toReturn.lpt = languages;
        }
        resolve(toReturn);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
